import { render } from "./AIQuestionPage.vue?vue&type=template&id=4aec57f6&scoped=true"
import script from "./AIQuestionPage.vue?vue&type=script&lang=js"
export * from "./AIQuestionPage.vue?vue&type=script&lang=js"

import "./AIQuestionPage.vue?vue&type=style&index=0&id=4aec57f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4aec57f6"]])

export default __exports__